module.exports = __webpack_public_path__ + "static/FMCG1-c7ec14e427a4529fa3eb859a6bf07504.png";